import angular from 'angular';
import moment from 'moment';
import '../services/errors';
import '../components/status';
import '../services/globals';

const module = angular.module('whyline.controllers.poll-answer', [
  'whyline.components.status',
  'whyline.services.poll',
  'whyline.services.errors',
  'whyline.services.globals',
]);

const PollAnswersController = ($scope, $timeout, PollService, $state, currentOrganization) => {
  /* @ngInject */

  $scope.pollAnswers = [];
  $scope.quantityOfItems = 8;
  $scope.selectedType = 'process';

  $scope.organizationId = currentOrganization._id;
  $scope.placeId = '*';
  $scope.serviceId = '*';
  $scope.today = moment().toDate();
  $scope.to = moment().toDate();
  $scope.from = moment().subtract(7, 'days').toDate();
  $scope.headers = ['answeredAt', 'place', 'question', 'response', 'service', 'comment'];
  $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate', 'dd/MM/yyyy'];
  $scope.format = $scope.formats[4];

  const setCalendarOptions = () => {
    $scope.dateOptionsFrom = {
      formatYear: 'yy',
      maxDate: $scope.today
    };
    $scope.dateOptionsTo = {
      formatYear: 'yy',
      minDate: $scope.from,
      maxDate: $scope.today
    };
    $scope.calendarDates = {
      from: $scope.from,
      to: $scope.to
    };
  };

  $scope.changeOptions = () => {
    $scope.dateOptionsTo = {
      minDate: $scope.from,
      maxDate: $scope.today,
      formatYear: 'yy',
    }
  }

  setCalendarOptions();

  $scope.refresh = () => {
    const params = {
      organizationId: $scope.organizationId,
      from: $scope.from,
      to: $scope.to,
    };

    PollService.GetAnswers(params).then((pollAnswers) => {
      $timeout(() => {
        $scope.pollAnswers = pollAnswers;
      });
    });
  };

  $scope.exportPollsAsCSV = () => {
    const params = {
      organizationId: $scope.organizationId,
      from: $scope.from,
      to: $scope.to,
    };

    PollService.GetAnswersExport(params);
  };

  $scope.syncPolls = () => {
    const params = {
      organizationId: $scope.organizationId,
      from: $scope.from,
      to: $scope.to,
    };

    return PollService.syncPolls(params);
  };

  $scope.refresh();
};

module.exports = module.controller('PollAnswersController', PollAnswersController);
